<app-basic-select [options]="['Yes', 'No']" [(ngModel)]="localValue" [title]="title" (ngModelChange)="onValueChange($event)"></app-basic-select>
